import { render, staticRenderFns } from "./AccettaInformativaProfiloSanitario.vue?vue&type=template&id=34559e23&"
import script from "./AccettaInformativaProfiloSanitario.vue?vue&type=script&lang=js&"
export * from "./AccettaInformativaProfiloSanitario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports